export default {
  english: {
    label: 'Categories',
    i24NewsPlusLink: '/en/i24news-plus',
    i24NewsPlusLabel: 'i24NEWS+',
  },
  french: {
    label: 'Catégories',
    i24NewsPlusLink: '/fr/i24news-plus',
    i24NewsPlusLabel: 'i24NEWS+',
  },
  arabic: {
    label: 'فئات',
    i24NewsPlusLink: '/ar/بلس-i24news',
    i24NewsPlusLabel: 'i24NEWS+',
  },
  hebrew: {
    label: 'קטגוריות',
    i24NewsPlusLink: '',
    i24NewsPlusLabel: '',
  },
  persian: {
    label: 'دسته بندی ها',
    i24NewsPlusLink: '',
    i24NewsPlusLabel: '',
  },
}
